/**
 * Map a user role string to a Badge variant for consistent role display.
 */
export function getRoleBadgeVariant(role: string): 'success' | 'default' | 'secondary' {
  if (role === 'SiteAdmin') return 'success';
  if (role === 'DataQualityAdmin') return 'default';
  return 'secondary';
}
